export const environment = {
  production: true,
  apiUrl: 'https://api-stg.hitead.com/api',
  google: {
    apiKey: "AIzaSyD-UgNdFvuGqtQLzif3KQYaQbBMQwe_RGA"
  },
  adyen: {
    apiKey: "pub.v2.8015438122250532.aHR0cHM6Ly93d3cuYWRsdXV4LmNvbQ.bUMIU8dhDkCroTi4UcnrLn7j7ZNo7puJ8h6UyE1kt6E"
  }  
};



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/environments/environment.ts